import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
    Button,
    Cascader,
    Divider,
    Select,
    Row,
    Col,
    Input,
    DatePicker,
    message,
    Radio,
    Spin,
    
} from 'antd'
import {
    PlusOutlined,
    LeftOutlined,
} from '@ant-design/icons';
import { isEmpty, isNotEmpty, samplingConstants, toThousands } from '../Service/Utils';
import UIFetchService from '../Service/UIFetchService';
import './EventAnalysis.css'
import ConditionsEditor from './ConditionsEditor'

const FunnelEditView = (props) => {

    const [funnel, setFunnel] = useState(null)

    useEffect(() => {
        if (props.funnelId == null) {
            return 
        }

        UIFetchService.get(`/api/v1/sampling/funnel/detail/${props.funnelId}`)
            .then((result) => {
                if (result) {
                    setFunnel(result)
                }
            })
    }, [props.funnelId])

    const title = props.funnelId == null ? "新建漏斗" : "编辑漏斗"

    return (
        <>
            <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }}>
                <Col style={{ margin: '0 20px 0 0' }}>
                    <span
                        style={{
                            color: 'gray',
                            cursor: 'pointer'
                        }}
                        onClick={() => window.location = '/real_time/funnel_analysis'}
                    ><LeftOutlined /> 返回</span>
                </Col>
                <Col>
                    <span>{title}</span>
                </Col>
            </Row>
            {
            funnel != null && funnel.status === 2 ? 
            <>
                {/* <Spin> */}
                <Row justify='center'>
                    <Col>
                        <img src="/no_event_data.png"></img>
                    </Col>
                </Row>
                {/* </Spin> */}
                <span>漏斗计算中，请稍后进行编辑</span> 
            </> : 
            <FunnelCreateModal funnel={funnel}/>
            }
        </>
    )
}

function FunnelCreateModal(props) {
    let activeFunnel = props.funnel == null ? {
        id: 0, 
        name: '', 
        steps: [{
            id: 1, 
            projectName: '',
            eventClassificationOptions:[
                { label: '事件分组', value: '事件分组', children: [] },
                { label: '事件类型', value: '事件类型', children: [] }
            ], 
            eventOptions: [], 
            propertiesSelector: null, 
            eventProperties: []
        }]
    } : props.funnel

    const [projectName, setProjectName] = useState(null)
    const [calcType, setCalcType] = useState(null)
    const [rangeDate, setRangeDate] = useState([undefined, undefined])
    const [funnel, setFunnel] = useState(activeFunnel)
    const [eventTypes, setEventTypes] = useState([])
    const [eventGroups, setEventGroups] = useState([])

    useEffect(() => {
        if (props.funnel != null) {
            setFunnel({
                id: props.funnel.id,
                name: props.funnel.name,
                steps: JSON.parse(props.funnel.funnelSteps)
            })
            setProjectName(props.funnel.projectName)
            setCalcType(props.funnel.calcType)
            if (props.funnel.calcType == 1 && props.funnel.rangeDate != null) {
                setRangeDate(JSON.parse(props.funnel.rangeDate).map(d => moment(d, 'YYYY-MM-DD')))
            }
        }
    }, [props.funnel])

    useEffect(() => {
        if (isNotEmpty(projectName)) {
            fetchEventTypeAndGroups(projectName)
        }

    }, [projectName])

    const fetchEventTypeAndGroups = async (projName) => {
        const types = await UIFetchService.get(`/api/v1/sampling/definitions/project/${projName}/eventTypes`)
        const groups = await UIFetchService.get(`/api/v1/sampling/definitions/project/${projName}/eventGroups`)

        setEventTypes(types)
        setEventGroups(groups)
    }

    const eventClassificationOptions = [
        { label: '事件分组', value: '事件分组', children: eventGroups == null ? [] : eventGroups.map(eg => { return { label: eg, value: eg, children: [] }}) },
        { label: '事件类型', value: '事件类型', children: eventTypes == null ? [] : eventTypes.map(et => { return { label: et, value: et, children: [] }}) }
    ]

    const _eventClassificationSelected = async (index, value) => {
        const eventNames = await UIFetchService.get(`/api/v1/sampling/definitions/project/${projectName}/eventNames?eventClassificationType=${value[0]}&eventClassificationValue=${value[1]}`)
        setFunnel({ 
            ...funnel,
            steps: [
                ...funnel.steps.slice(0, index),
                funnel.steps[index] = { 
                    ...funnel.steps[index],
                    classificationType: value[0],
                    classificationValue: value[1],
                    eventOptions: eventNames,
                    propertiesSelector: null,
                    eventProperties: []
                },
                ...funnel.steps.slice(index + 1)
            ]
         })
    }

    const eventSelected = async (index, value) => {
        const props = await getEventProperties(funnel.steps[index])
        
        setFunnel({
            ...funnel,
            steps: [
                ...funnel.steps.slice(0, index),
                funnel.steps[index] = { 
                    ...funnel.steps[index],
                    eventName: value,
                    propertiesSelector: null,
                    eventProperties: props
                },
                ...funnel.steps.slice(index + 1)
            ]
        })
    }

    const statisticObjectSelected = (index, value) => {
        setFunnel({
            ...funnel,
            steps: [
                ...funnel.steps.slice(0, index),
                funnel.steps[index] = { 
                    ...funnel.steps[index],
                    statisticObject: value
                },
                ...funnel.steps.slice(index + 1)
            ]
        })        
    }

    const getEventProperties = async (step) => {
        let eventGroup = null
        if (step.classificationType === '事件分组') {
            eventGroup = step.classificationValue
        }

        return await UIFetchService.get(`/api/v1/sampling/event/eventProperties?projectName=${projectName}&eventName=${step.eventName}&eventGroup=${eventGroup == null ? '' : eventGroup}`)
    }

    const showPropertiesSelector = async (step, index) => {
        let eventProperties = step.eventProperties
        if (eventProperties == null || eventProperties.length === 0) {
            const props = await getEventProperties(step)
            if (props != null) {
                eventProperties = props
            }
        }

        if (step.propertiesSelector == null) {
            setFunnel({ 
                ...funnel,
                steps: [
                    ...funnel.steps.slice(0, index),
                    funnel.steps[index] = { 
                        ...funnel.steps[index],
                        propertiesSelector: {
                            root: true,
                            logic: 'OR',
                            type: 'LOGIC',
                            nodes: [
                                {
                                    type: 'EVE_PROP'
                                }
                            ]
                        },
                        eventProperties: eventProperties
                    },
                    ...funnel.steps.slice(index + 1)
                ]
             })
        }
    }

    const syncPropertiesSelector = (index, conds) => {
        setFunnel({
            ...funnel,
            steps: [
                ...funnel.steps.slice(0, index),
                funnel.steps[index] = { 
                    ...funnel.steps[index],
                    propertiesSelector: conds
                },
                ...funnel.steps.slice(index + 1)
            ]
        })           
    }

    const saveFunnel = async () => {
        if (isEmpty(funnel.name)) {
            message.error('请填写漏斗名称')
            return
        }

        if (calcType == null) {
            message.error('请选择计算方式')
            return
        }

        let rangeDateArr = null

        if (calcType === 1) {
            if (rangeDate[0] == null || rangeDate[1] == null) {
                message.error('在计算方式为“单日计算”时，请选择计算日期')
                return
            }
            if (rangeDate[1].diff(rangeDate[0], 'day') > 180) {
                message.error('计算日期最长不超过 180 天')
                return
            }

            rangeDateArr = [rangeDate[0].format('YYYY-MM-DD'), rangeDate[1].format('YYYY-MM-DD')]
        }

        const steps = funnel.steps
        if (steps == null || steps.length < 2) {
            message.error('漏斗至少需要两个步骤')
            return
        }

        for (const step of steps) {
            if (isEmpty(step.eventName) || isEmpty(step.statisticObject)) {
                message.error('请将漏斗步骤填写完整')
                return
            }
            step.projectName = projectName
        }

        const request = {
            id: funnel.id,
            name: funnel.name,
            projectName: projectName,
            calcType: calcType,
            rangeDate: rangeDateArr,
            steps: JSON.stringify(steps)
        }
        const id = await UIFetchService.post('/api/v1/sampling/funnel/', request)
        if (id == null) {
            message.error("漏斗保存失败")
            return
        }
        if (funnel.id === 0)  {
            funnel.id = id
        }
        message.success("保存漏斗成功")
        _doQuery()
    }

    const _doQuery = async () => {
        const requestBody = { 
            type: 'history', 
            funnelId: funnel.id,
            conditions: funnel.steps.map(s => { 
                return {
                    id: s.id,
                    projectName: s.projectName, 
                    eventGroup: s.classificationType === '事件分组' ? s.classificationValue : null,
                    eventName: s.eventName, 
                    statisticObject: s.statisticObject,
                    propertiesSelector: s.propertiesSelector
                }
            })
        }
        
        if (calcType === 1) {
            requestBody.startDate = rangeDate[0].format('YYYY-MM-DD')
            requestBody.endDate = rangeDate[1].format('YYYY-MM-DD')
        } else {
            requestBody.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD')
            requestBody.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
        }
        
        const result = await UIFetchService.post('/api/v1/sampling/funnel/query', requestBody)
        if (result == null || Object.keys(result).length === 0) {
            return
        }

        window.location = '/real_time/funnel_analysis'
    }
   

    return (
        <div style={{padding: 20}}>
            <Row style={{margin: '20px 0'}}>
                <Col flex='450px'>
                    <Row>
                        <Col flex="100px" style={{ alignSelf: 'center' }}>
                            <span>项目组：</span>
                        </Col>
                        <Col flex='300px'>
                            <Select
                                value={projectName}
                                onChange={projectName => {
                                    setProjectName(projectName)
                                }}
                                style={{ width: '100%' }}
                            >
                                {samplingConstants.projects.map(project => <Select.Option value={project.value}>
                                    {project.title + " (" + project.value + ")"}
                                </Select.Option>)}
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{marginTop: 20}}>
                        <Col flex="100px">
                            <span>漏斗名称:</span>
                        </Col>
                        <Col flex="300px">
                            <Input style={{width: '100%'}} value={funnel.name} onChange={(e) => setFunnel({
                                ...funnel,
                                name: e.target.value
                            })} />
                        </Col>
                    </Row>
                </Col>
                <Col flex='auto'>
                    <Row>
                        <Col flex='100px'>
                            <span>计算方式：</span>
                        </Col>
                        <Col flex='300px'>
                            <Radio.Group onChange={(e) => { setCalcType(e.target.value) }} value={calcType}>
                                <Radio value={1}>单次计算</Radio>
                                <Radio value={2}>每日更新</Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                    { calcType != 1 ? null : 
                    <Row style={{marginTop: 10}}>
                        <Col flex='100px'>
                        </Col>
                        <Col>
                            <DatePicker.RangePicker 
                                // style={{margin: '10px 10px 0 0'}}
                                value={rangeDate} 
                                onChange={d => setRangeDate(d)} 
                            /> 
                        </Col>
                    </Row>
                    }
                    <Row style={{marginTop: 20}}>
                        <Col style={{color: '#777'}}>
                            <ul style={{textAlign: 'left'}}>
                            <li><span>单次计算：可自定义时间范围，漏斗保存后只计算一次，后续不会自动刷新数据</span></li>
                            <li><span>每日更新：不可自定义时间范围，漏斗保存后每日定时刷新近7日数据</span></li>
                            </ul>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row style={{marginTop: 20}}>
                <Col flex="100px">
                    <span>漏斗步骤:</span>
                </Col>
            </Row>
            { funnel.steps.map((s, index) => <div className='funnel-selector'>
            <Row>
                <Col flex='40px'>
                    <div className='step-number'> { s.id } </div>
                </Col>
                <Col style={{paddingLeft: 6, paddingRight: 6}}>
                    <Cascader className='tmplCascader'
                        options={eventClassificationOptions} 
                        value={s.classificationType != null ? [s.classificationType, s.classificationValue] : []}
                        onChange={ async value => _eventClassificationSelected(index, value)} 
                        placeholder="事件分类" 
                        style={{ width: 180 }}
                    />
                </Col>
                <Col style={{paddingLeft: 6, paddingRight: 6}}>
                    <Select className='tmplSelector'
                        showSearch
                        filterOption={(input, option) => {
                            return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }}
                        placeholder="任意事件"
                        value={s.eventName}
                        style={{ width: 300 }}
                        onChange={ async value => eventSelected(index, value) }
                    >
                        { s.eventOptions != null ? s.eventOptions.map(e => <Select.Option key={e.eventNameChs + e.eventName} value={e.eventNameChs}> {e.eventNameChs + ' ' + e.eventName} </Select.Option>) : null}
                    </Select>
                </Col>
                <Col style={{paddingLeft: 6, paddingRight: 6}}>
                    <span>&nbsp;的&nbsp;</span>
                </Col>
                <Col style={{paddingLeft: 6, paddingRight: 6}}>
                    <Select className='tmplSelector'
                        placeholder="统计值"
                        value={s.statisticObject}
                        style={{ width: 150 }}
                        onChange={ async value => statisticObjectSelected(index, value) }
                    >
                        <Select.Option value='times'> 总次数 </Select.Option>
                        <Select.Option value='users'> 总用户数 </Select.Option>
                        <Select.Option value='devices'> 总设备数(device_id) </Select.Option>
                    </Select>                       
                </Col>
                    <Col flex="120px">
                        <Button
                            size="small"
                            type="link"
                            onClick={ () => showPropertiesSelector(s, index) }
                        >
                            筛选
                        </Button>
                        <Button
                            danger
                            size="small"
                            type="link"
                            onClick={ ()=> {
                                setFunnel({
                                    ...funnel,
                                    steps: [
                                        ...funnel.steps.slice(0, index),
                                        ...funnel.steps.slice(index + 1)
                                    ]
                                })
                            } }
                        >
                            删除
                        </Button>
                    </Col>
            </Row>
            <Row style={{marginTop: 3}}>
                <Col flex='40px'></Col>
                <Col flex='900px'>
                    {s.propertiesSelector == null ? null : 
                    <ConditionsEditor 
                        className='event-condition-card'
                        editable={true}
                        conditions={s.propertiesSelector} 
                        eventProperties={s.eventProperties} 
                        syncConditions={(conds) => syncPropertiesSelector(index, conds) } />
                    }
                </Col>
            </Row>
            </div>)
            } 
            <Row style={{marginLeft: 20}}>
                <Col>
                    <Button type='primary' ghost icon={<PlusOutlined />} onClick={() => {
                        if (funnel.steps.length >= 9) {
                            message.error("漏斗步骤不能超过 9 个")
                            return
                        }

                        let id = 1
                        if (funnel.steps.length > 0) {
                            id = Math.max(...funnel.steps.map(s => s.id)) + 1
                        }
                        setFunnel(
                            { 
                                ...funnel, 
                                steps: [
                                    ...funnel.steps, 
                                    { 
                                        id: id, 
                                        projectName: projectName,
                                        eventClassificationOptions:[ 
                                            { label: '事件分组', value: '事件分组', children: [] },
                                            { label: '事件类型', value: '事件类型', children: [] }
                                        ],
                                        eventOptions: [], 
                                        propertiesSelector: null, 
                                        eventProperties: [] 
                                    }
                                ]
                            }
                        )
                    }}>
                        点击添加步骤
                    </Button>
                </Col>
            </Row>
            <Divider />
            <Row style={{margin: '40px 20px'}} >
                <Col>
                    <Button onClick={ () => {
                        saveFunnel()
                    } } type='primary'>保存漏斗</Button>
                </Col>
                <Col flex='50px'>
                </Col>
                <Col>
                    <Button onClick={() => {
                        window.location = '/real_time/funnel_analysis'
                    }}>取消</Button>
                </Col>
            </Row>
        </div>
    )
}

export default FunnelEditView